import { $, $$, setElementFocus } from 'dlr-utils/helpers';

/**
 * IMPORTANT: THIS WILL ALWAYS BE AN ARRAY
 * Always make it possible for multiple instances
 * of your module to work on the pages.
 */
const SELECTOR = '.dlr-content-grid';
const INSTANCES = $$(SELECTOR);

/* If you want to target just one, just uncomment the line below */
// const ELEMENT = SELECTOR[0];

/**
 * 1. Mounting
 *
 * Put module-specific variables and functions here.
 * Actions in this scope will fire as soon as the module
 * is mounted (not yet attached to the page)
 *  e.g. setting of initial states (see below), data fetching, etc
 *
 * The default export functions are the only
 * ones used by the dynamic module importer (main.js).
 * upon page load. main.js will only fire these if
 * at least one element with the class ".dlr-content-grid" exists
 */
const AJAX_URL = window.dlr_ajax.ajax_url;
const IS_HIDDEN = '--is-hidden';

export default {
  /**
   * 2. REGISTRATION
   *
   * Use `init` for actions that should fire as soon as
   * the module file has been made available to the page
   *  - e.g. data transformations, MessageBus Subscriptions
   */
  init(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;
    console.log('content-grid init');

    MessageBus.subscribe('LOADMORE_HANDLER', ({ module, loadmoreBtn }) => {
      const cardsContainer = $(`${SELECTOR}__cards-items`, module);
      const page = parseInt(cardsContainer.getAttribute('page'));
      const total = parseInt(cardsContainer.getAttribute('total'));
      const contentType = cardsContainer.getAttribute('content-type');
      const loadmoreContainer = loadmoreBtn.parentNode;

      let fetch_URL = AJAX_URL;
      let fetch_OBJECT = {
        method: 'POST',
        credentials: 'same-origin',
        headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
        body: `action=fetch_content_cards&page=${page + 1}&content_type=${contentType}`,
      };

      loadmoreBtn.setAttribute('disabled', true);

      // for FE styleguide
      const isFEStyleguide = document.body.classList.contains('fe-styleguide');
      if (isFEStyleguide) {
        fetch_URL = `/styleguide/content-grid-fe-ajax?page=${page+1}`;
        fetch_OBJECT = {};
      }

      fetch(fetch_URL, fetch_OBJECT)
        .then(res => res.text())
        .then(html => {
          // Convert the HTML string into a document object
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const cards = $$(`${SELECTOR}__card`, doc);

          cards.forEach((card, index) => {
            cardsContainer.append(card);
            index == 0 && setTimeout(() => setElementFocus(card), 20);
          });

          cardsContainer.setAttribute('page', page+1);

          // remove disabled attr
          loadmoreBtn.removeAttribute('disabled');

          // hide/show loadmore container
          const totalCards = $$(`${SELECTOR}__card`, cardsContainer).length;
          totalCards >= total ?
            loadmoreContainer.classList.add(IS_HIDDEN) :
            loadmoreContainer.classList.remove(IS_HIDDEN);
        });
    });
  },

  /**
   * 3. RENDERING
   *
   * Use `finalize` for actions that should run
   * as soon as the module is rendered to the page
   * - e.g. Event Listeners, DOM Manipulations,
   *        MessageBus Publishers, etc
   */
  finalize(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;
    console.log('content-grid finalize');

    INSTANCES.forEach(module => {
      const loadmoreBtn = $(`${SELECTOR}__cards-loadmore button`, module);

      loadmoreBtn.addEventListener('click', e => MessageBus.publish('LOADMORE_HANDLER', { module: module, loadmoreBtn: loadmoreBtn }));
    });
  },
};



// WEBPACK FOOTER //
// ../views/modules/content-grid/content-grid.js